import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Skeleton, SkeletonLines } from '../../../skeleton/src';
/** Default prefetch distance (px) from the bottom that triggers `onLoadMore`. */
export const DEFAULT_LOAD_MORE_THRESHOLD = 800;
/**
 * Default overscan distance (px) rendered outside the viewport in both directions for smooth scrolling.
 * At ~60 px per item this is roughly 5 items of buffer above and below.
 */
export const DEFAULT_OVERSCAN_DISTANCE = 300;
/** Default minimum card width (px) for the responsive auto-fill grid. */
export const DEFAULT_MIN_ITEM_WIDTH = 240;
/** Translates a number to a px string, leaving strings (e.g. `'1rem'`, `'20%'`) untouched. */
export const toCssSize = (value) => (typeof value === 'number' ? `${value}px` : value);
/**
 * Builds react-virtuoso's `computeItemKey` from the public `itemKey` prop. Returns `undefined` when no key is
 * provided so virtuoso falls back to the item index.
 */
export const toComputeItemKey = (itemKey) => itemKey
    ? (index, item) => typeof itemKey === 'function' ? itemKey(item, index) : item[itemKey]
    : undefined;
/**
 * Returns an `endReached` handler that only invokes `onLoadMore` when there is another page to fetch and one is not
 * already in flight — preventing duplicate fetches as virtuoso re-renders the tail of the list.
 */
export const useEndReached = ({ onLoadMore, hasNextPage, isLoadingMore }) => useCallback(() => {
    if (onLoadMore && hasNextPage && !isLoadingMore) {
        onLoadMore();
    }
}, [onLoadMore, hasNextPage, isLoadingMore]);
/** Skeleton footer shown beneath a `VirtualList` while the next page loads. */
export const ListLoadingFooter = () => (_jsx("div", { className: 'nucleus-px-4 nucleus-py-3', "data-testid": 'nucleus-virtual-list--loading-more', children: _jsx(SkeletonLines, { count: 2, lastLineWidth: '60%' }) }));
/** Skeleton footer shown beneath a `VirtualGrid` while the next page loads. */
export const GridLoadingFooter = () => (_jsx("div", { className: 'nucleus-flex nucleus-gap-4 nucleus-px-4 nucleus-py-3', "data-testid": 'nucleus-virtual-grid--loading-more', children: Array.from({ length: 3 }).map((_, index) => (
    // eslint-disable-next-line react/no-array-index-key
    _jsx(Skeleton, { variant: 'line', height: 120, className: 'nucleus-flex-1 nucleus-rounded-lg' }, index))) }));
//# sourceMappingURL=virtual_list.internal.js.map